import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import tuweLogo from "../images/tuwe-logo-pink-copy.png";
import "../styles/header.css";
import { useMediaQuery } from "react-responsive";
import MediaSidebarItem from "./MediaSidebarItem";
import { RxCross2 } from "react-icons/rx";
import { MediaSidebarData } from "./MediaSidebarData";
import "../styles/sidebar.css";

const Header = () => {
  const location = useLocation();
  const isActivePath = (path) => location.pathname === path;
  const isBelow1099 = useMediaQuery({ query: "(min-width: 1150px)" });
  const [sidebar, setSidebar] = useState(false);

  const showSideBar = () => {
    setSidebar(!sidebar);
  };

  const hideDonateButton =
    location.pathname === "/donate" ||
    location.pathname.startsWith("/response");

  // Decide which menu to show
  const renderNavLinks = () => {
    if (location.pathname === "/donate") {
      return (
        <ul>
          <li><a href="/">Home</a></li>
        </ul>
      );
    }

 
    return (
      <ul>
        <li>
          <a href="/" className={isActivePath("/") ? "active" : ""}>Home</a>
        </li>
 
        <li><a href="#about-us"> About Us</a></li>
         
        <li><a href="#programs">Programs</a></li>
         <li><a href="#join-us">Join Us</a></li>
       </ul>
    );
  };

  /* ----------------------------------
     HEADER SCROLL STATE
  ---------------------------------- */
  useEffect(() => {
    const body = document.body;
    const header = document.querySelector("#header");

    if (
      !header ||
      (!header.classList.contains("fixed-top") &&
        !header.classList.contains("sticky-top"))
    ) {
      return;
    }

    const forceScrolledRoutes = ["/response", "/donate", "/values"];

    const shouldForceScrolled = forceScrolledRoutes.some((path) =>
      location.pathname.startsWith(path)
    );

    const toggleScrolled = () => {
      if (shouldForceScrolled) {
        body.classList.add("scrolled");
        return;
      }

      window.scrollY > 100
        ? body.classList.add("scrolled")
        : body.classList.remove("scrolled");
    };

    toggleScrolled();

    window.addEventListener("scroll", toggleScrolled);
    window.addEventListener("load", toggleScrolled);

    return () => {
      window.removeEventListener("scroll", toggleScrolled);
      window.removeEventListener("load", toggleScrolled);
    };
  }, [location.pathname]);

  /* ----------------------------------
     NAV ACTIVE STATE (PER SECTION)
  ---------------------------------- */
useEffect(() => {
  const pageLink = document.querySelector(
    `.navmenu a[href="${location.pathname}"]`
  );

  const sectionLinks = document.querySelectorAll(".navmenu a[href^='#']");
  const sections = Array.from(sectionLinks)
    .map(link => document.querySelector(link.getAttribute("href")))
    .filter(Boolean);

  if (!sections.length) return;

  // Track which sections are currently visible
  const visibleSections = new Set();

  const handleIntersect = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visibleSections.add(entry.target.id);
      } else {
        visibleSections.delete(entry.target.id);
      }
    });

    // Clear all first
    sectionLinks.forEach(l => l.classList.remove("active"));
    pageLink?.classList.remove("active");

    // Activate the last visible section (priority to bottom-most in DOM)
    const orderedSections = sections
      .map(s => s.id)
      .filter(id => visibleSections.has(id));

    if (orderedSections.length > 0) {
      const activeId = orderedSections[orderedSections.length - 1];
      const activeLink = document.querySelector(
        `.navmenu a[href="#${activeId}"]`
      );
      activeLink?.classList.add("active");
    } else {
      // Fallback to Home if nothing is visible
      pageLink?.classList.add("active");
    }
  };

  // 🔹 Observers
  const viewportObserver = new IntersectionObserver(handleIntersect, {
    root: null,
    threshold: 0,
    rootMargin: "-40% 0px -40% 0px", // activation band for tall sections
  });

  const shortSectionObserver = new IntersectionObserver(handleIntersect, {
    root: null,
    threshold: Array.from({ length: 101 }, (_, i) => i / 100), // precise detection
  });

  const contactObserver = new IntersectionObserver(handleIntersect, {
    root: null,
    rootMargin: "-70% 0px -50% 0px",
    threshold: Array.from({ length: 101 }, (_, i) => i / 100), // footer detection
  });

  // Attach observers
  sections.forEach(section => {
    if (section.id === "our-team") {
      shortSectionObserver.observe(section);
    } else if (section.id === "contact") {
      contactObserver.observe(section);
    } else {
      viewportObserver.observe(section);
    }
  });

  return () => {
    viewportObserver.disconnect();
    shortSectionObserver.disconnect();
    contactObserver.disconnect();
  };
}, [location.pathname]);


  return (
    <header id="header" className="header d-flex align-items-center fixed-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="/" className="logo d-flex align-items-center me-auto">
          <img src={tuweLogo} alt="Tuwe Initiative" />
          <h1 className="sitename">Tuwe Initiative</h1>
        </a>

        <nav id="navmenu" className="navmenu">
          {renderNavLinks()}

          <i
            className="mobile-nav-toggle d-xl-none bi bi-list"
            onClick={showSideBar}
          />

          <div className={sidebar ? "sidebar active" : "sidebar"}>
            <div className="sidebar-header">
              <a href="/" className="logo d-flex align-items-center me-auto">
                <img src={tuweLogo} alt="Tuwe Initiative" />
              </a>
              <RxCross2 className="cross-btn" onClick={showSideBar} />
            </div>

            {MediaSidebarData.map((item, index) => (
              <MediaSidebarItem
                key={index}
                item={item}
                onClick={showSideBar}
              />
            ))}
          </div>
        </nav>

        {!hideDonateButton && isBelow1099 && (
          <a href="/donate" className="donate-btn header-donate-btn">
            Donate
          </a>
        )}
      </div>
    </header>
  );
};

export default Header;
